export var COLORS;
(function (COLORS) {
    COLORS["BgMain"] = "#FFFFFF";
    COLORS["BgSurface"] = "#F5F8FB";
    COLORS["BgSubstrate"] = "#F9FCFD";
    COLORS["BgLight"] = "#FAFAFA";
    COLORS["BgSecondary"] = "#EEEEEF";
    COLORS["BgError"] = "#FDEEEE";
    COLORS["BgSuccess"] = "#EEFFF5";
    COLORS["ButtonAccent"] = "#FF312C";
    COLORS["ButtonPrimary"] = "#1E1F33";
    COLORS["ButtonSecondary"] = "#E0EBF0";
    COLORS["ButtonWhite"] = "#FFFFFF";
    COLORS["TextPrimary"] = "#181B21";
    COLORS["TextSecondary"] = "#393C41";
    COLORS["TextInfo"] = "#5C5E62";
    COLORS["TextHint"] = "#74767A";
    COLORS["TextDisabled"] = "#C5C6C7";
    COLORS["TextWhite"] = "#FFFFFF";
    COLORS["Success"] = "#69C48F";
    COLORS["Error"] = "#FF7B7B";
    COLORS["Logo"] = "#FF312C";
    COLORS["Locked"] = "#FFB0B0";
    COLORS["Link"] = "#518399";
    COLORS["Outline_Dark"] = "#9BCDDD";
    COLORS["Digital_Blue"] = "#75C1D9";
    COLORS["Brand_Blue"] = "#AFDAE8";
    COLORS["Disabled"] = "#BBCCD4";
    COLORS["Outline_Light"] = "#E0EBF0";
    COLORS["Control"] = "#181B21";
    COLORS["GRAY_DARK"] = "#74767A";
    COLORS["GRAY_LIGHT"] = "#C5C6C7";
    COLORS["LabelsText_1"] = "#10B278";
    COLORS["LabelsText_2"] = "#EE516E";
    COLORS["LabelsText_3"] = "#E7910E";
    COLORS["LabelsText_4"] = "#85558C";
    COLORS["LabelsText_5"] = "#007AE5";
    COLORS["LabelsText_6"] = "#6176E6";
    COLORS["LabelsBg_1"] = "#DBF5EB";
    COLORS["LabelsBg_2"] = "#FDE1E1";
    COLORS["LabelsBg_3"] = "#FFE9C8";
    COLORS["LabelsBg_4"] = "#E6D8E8";
    COLORS["LabelsBg_5"] = "#C6E1F9";
    COLORS["LabelsBg_6"] = "#DFE3FB";
    COLORS["transparent"] = "transparent";
})(COLORS || (COLORS = {}));
